module.exports = __webpack_public_path__ + "static/img/cont39_01.9dae641.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news/cont39_01.png
// module id = 1AmV
// module chunks = 0